import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import UtilsUrl from "../utils/UtilsUrl";

import { useNavigate } from "react-router-dom";

const dateFormatter = (originalDate) => {
  if (!originalDate || isNaN(new Date(originalDate).getTime())) {
    return "-";
  }

  const date = new Date(originalDate);
  const formattedDate = date.toLocaleDateString("fr-FR", {
    weekday: "long", // Full weekday name
    year: "numeric",
    month: "long", // Full month name
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return formattedDate;
};


const DataTableProductTransation = ({ listProduits }) => {
  const navigate = useNavigate();
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [quantityFilter, setQuantityFilter] = useState("");

  const { SearchBar } = Search;

  const filteredProduits = listProduits.filter((product) =>
    quantityFilter !== ""
      ? product.quantity === parseInt(quantityFilter, 10)
      : true
  );

  const columns = [

    {
      dataField: "name",
      text: "Libelle",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (cell ? cell : "-"), // Check if `name` exists, otherwise fallback to "-"
    },
    {
      dataField: "reference",
      text: "Reference",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
      formatter: (cell, row) => {
        return (
          <button // Replace `row.id` with the field containing the ticket ID
            style={{ textDecoration: "none", color: "blue", background: "none", border: "none" }}
            onClick={() => {
              if (row.type === "Order") {
                console.log(row.reference)
                localStorage.setItem("reference", row.reference)

                navigate('/ticket-detail')
              }
            }}
          >
            {cell}
          </button>
        );
      },
    }
    ,
    {
      dataField: "type",
      text: "Type",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (cell === "BDCommande" ? "Bon de commande achat" : cell === "BDCommandSale" ? "Bon de commande vente" : cell === "Order" ? "Ticket de caisse" : cell === "Production" ? "Ordre de production" : cell === "Transfert" ? "transfert" : "-"),
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "creationDate", // Use the primary key as dataField
      text: "Date de création", // Corrected typo
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
      formatter: (cell, row) => {
        // Check for both possible keys during formatting
        const value = row.creationDate || row.creation_date;
        return dateFormatter(value); // Use the dateFormatter for display
      },
    },

    {
      dataField: "quantity",
      text: "Quantité",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const pageButtonRenderer = ({ page, active, onPageChange }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = active
      ? { backgroundColor: "black", color: "white" }
      : { backgroundColor: "white", color: "black" };
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };

  const options = {
    pageButtonRenderer,
  };

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i className="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Transaction</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={filteredProduits}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    placeholder="Chercher"
                  />
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};

export default DataTableProductTransation;
